module.exports = __webpack_public_path__ + "static/media/female-singer_1f469-200d-1f3a4.ce82e85f.png";